import { TProject, TProjectsApiResponse } from '../../types/config';
import { getInAreaSquareBounds, processProject } from '../../hardcode/utils';
import { fetchData } from './fetch-data';

export async function getProjectsInArea(project: TProject, apiUrl: string, awsUrl: string) {
  const projectsInAreaRes: TProjectsApiResponse | null = await fetchData(
    apiUrl,
    'api/public/projects',
    'POST',
    {
      limit: 20,
      options: {
        ...getInAreaSquareBounds(project?.lat, project?.lng, 5, true),
        addressSpecific: false,
        yad2Addresses: {
          yad2HoodId: project?.yad2HoodId,
          yad2StreetId: project?.yad2StreetId,
          yad2CityId: project?.yad2CityId,
          yad2AreaId: project?.yad2AreaId,
          yad2TopAreaId: project?.yad2TopAreaId,
        },
        searchOp: 'OR',
      },
    },
  );

  const processed =
    projectsInAreaRes?.data.projects
      ?.map((p) => processProject(p, awsUrl) as TProject)
      .filter((p) => p.id !== project.id) || [];

  return processed;
}
